/** 控制台双主题：天空蓝（#409eff + 顶栏一级菜单）/ 深蓝（#0057B4 + 侧栏全量菜单） */

import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { dispatchEchartsThemeRefresh } from '@/utils/chart-theme-colors'

const STORAGE_KEY = 'dashboard-nav-theme'
const CLASS_SKY = 'dashboard-theme-sky'
const CLASS_DEEP = 'dashboard-theme-deep'
const CHANGE_EVENT = 'dashboard-nav-theme-change'

export type DashboardNavTheme = 'sky' | 'deep'

let currentTheme: DashboardNavTheme = 'deep'

function normalizeStoredTheme (v: string | null): DashboardNavTheme | null {
  if (v === 'sky' || v === 'jp') return 'sky'
  if (v === 'deep' || v === 'classic') return 'deep'
  return null
}

/** 无本地记录时的默认主题：标准版=深蓝；日文专版=国际版(天空蓝) */
export function getDefaultDashboardNavTheme (): DashboardNavTheme {
  return IS_JP_ONLY_BUILD ? 'sky' : 'deep'
}

function readStoredTheme (): DashboardNavTheme | null {
  try {
    return normalizeStoredTheme(localStorage.getItem(STORAGE_KEY))
  } catch {
    return null
  }
}

function applyHtmlClass (theme: DashboardNavTheme) {
  const root = document.documentElement
  root.classList.remove(CLASS_SKY, CLASS_DEEP, 'dashboard-theme-jp', 'dashboard-theme-classic')
  root.classList.add(theme === 'sky' ? CLASS_SKY : CLASS_DEEP)
}

export function getDashboardNavTheme (): DashboardNavTheme {
  return currentTheme
}

/** 天空蓝主题：一级菜单在顶栏 */
export function isSkyDashboardNavTheme (theme: DashboardNavTheme = currentTheme): boolean {
  return theme === 'sky'
}

export function setDashboardNavTheme (theme: DashboardNavTheme) {
  currentTheme = theme
  applyHtmlClass(theme)
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // ignore
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: theme }))
  dispatchEchartsThemeRefresh()
}

export function toggleDashboardNavTheme (): DashboardNavTheme {
  const next: DashboardNavTheme = currentTheme === 'sky' ? 'deep' : 'sky'
  setDashboardNavTheme(next)
  return next
}

/** 应用启动时调用（main.ts，早于 mount） */
export function initDashboardNavTheme () {
  const theme = readStoredTheme() ?? getDefaultDashboardNavTheme()
  currentTheme = theme
  applyHtmlClass(theme)
}

export function onDashboardNavThemeChange (handler: (theme: DashboardNavTheme) => void) {
  const listener = (e: Event) => {
    const detail = (e as CustomEvent<DashboardNavTheme>).detail
    handler(detail ?? getDashboardNavTheme())
  }
  window.addEventListener(CHANGE_EVENT, listener)
  return () => window.removeEventListener(CHANGE_EVENT, listener)
}
